import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../css/images/preflop-mastery-logo-wide.png";

export default function NEWNavBar({ logout, subscriptionStatus }) {
	const [showSettings, setShowSettings] = useState(false);
	const menuRef = useRef(null);

	useEffect(() => {
		if (!showSettings) return;

		function handleClickOutside(event) {
			if (menuRef.current && !menuRef.current.contains(event.target)) {
				setShowSettings(false);
			}
		}

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [showSettings]);

	return (
		<div className="navbar">
			<img className="nav-logo" src={logo} alt="logo" />
			<ul className="nav-menu">
				<li>
					<Link to="/ranges">
						<i className="fa-solid fa-layer-group" />
						Ranges
					</Link>
				</li>
				<li>
					<Link to="/trainer">
						<i className="fa-solid fa-trophy" />
						Trainer
					</Link>
				</li>
				<li>
					<Link to="/data">
						<i className="fa-solid fa-chart-line" />
						Data
					</Link>
				</li>
			</ul>
			<div className="nav-settings" onClick={() => setShowSettings(!showSettings)} ref={menuRef}>
				<i className="nav-settings-icon fa-solid fa-gear"></i>
				<ul className={`nav-settings-menu ${showSettings ? "" : "display-none"}`}>
					<Link to="/my-account">
						<li className="nav-settings-menu-item">
							<i className="fas fa-user" />
							My Account
						</li>
					</Link>
					<Link to="/settings">
						<li className="nav-settings-menu-item">
							<i className="fa-solid fa-cog" />
							Settings
						</li>
					</Link>
					<Link to="/subscribe">
						<li className="nav-settings-menu-item">
							<i className="fas fa-coins" />
							Subscribe
						</li>
					</Link>
					<Link to="/feedback">
						<li className="nav-settings-menu-item">
							<i className="fas fa-comment-dots" />
							Feedback
						</li>
					</Link>
					<Link to="/login" onClick={() => logout()}>
						<li className="nav-settings-menu-item">
							<i className="fas fa-right-from-bracket" />
							Logout
						</li>
					</Link>
				</ul>
			</div>
		</div>
	);
}
